export const RELATIVE_Z2001 = { position: 'relative', zIndex: 2001 };
export const WIDTH_7_5VW = { width: '7.5vw' };

export const VIEWBOX = {
  SIZE_512: '0 0 512 512',
  SIZE_576: '0 0 576 512',
  SIZE_448: '0 0 448 512',
  SIZE_496: '0 0 496 512',
  SIZE_24: '0 0 24 24',
  SIZE_AUTOCOMPLETE: '0 0 707.77069 511.04553',
};
